import { user } from 'ampersand-app'
import { isEmpty } from 'lodash'

/**
 * return true if the todo item is assigned to the current user.
 * @param {import('@/modules/todo/todoService').Todo} todoItem
 * @return {boolean}
 */
const isTodoAssignedToMe = (todoItem) => {
  let { metaData = [] } = todoItem
  if (isEmpty(metaData)) metaData = []

  return metaData.some(meta => meta.type === 'user' && meta.id === user.id)
}

export default isTodoAssignedToMe
